import ConcernCategoryItemContainer from './ConcernCategoryItemContainer';

export default ConcernCategoryItemContainer;
